import { createGlobalStyle } from 'styled-components';

import SourceSansProBold from '@/assets/fonts/source-sans-pro-bold.woff';

const VariationStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBold';
    src: url(${SourceSansProBold});
    font-weight: bold;
    font-style: normal;
  }

  .generated-images-holder-var9 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var9 {
    width: 100%;
    position: relative;
    height: 1350px;
  }
 
  .bottom-text-var9 {
    position: absolute;
    bottom: 77px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 60px;
    line-height: 1.2;
    letter-spacing: -1.3px;
    color: #2f2f2f;
    text-align: center;
    font-family: SourceSansProBold;
    z-index: 1;
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 16px 47px 23px;
      border-radius: 25px;
    }
  }
  .full-image-var9 {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .circle-image-var9 {
    object-fit: cover;
    border-radius: 50%;
    border: solid 12px white;
    width: 381px;
    height: 381px;
    position: absolute;
    top: -415px;
    right: 63px;
    &.position-left {
      left: 63px;
      right: auto;
    }
    &.position-custom {
      bottom: auto;
      right: auto;
    }
  }

  .text-emoji-var9 {
    margin-left: 12px;
    margin-bottom: -15px;
  }

  .watermark-var9 {
    position: absolute;
    bottom: 9px;
    right: 40px;
  }
  .logo-watermark-var9 {
    position: absolute;
    top: 38px;
    left: 69px;
  }
  .breaking-news-var9 {
    position: absolute;
    top: 38px;
    right: 65px;
  }
  .actual-photo-var9 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var9--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationStyles;
